import React, {useState} from "react";
import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FaCircleNotch} from "react-icons/fa";



export function MySearchBar({
  keyword,
  setKeyword,
  onReload, 
  hint = 'Filter here...', 
}) {

  // Chakra Color Mode
  const mainTeal = useColorModeValue("teal.300", "teal.300");
  const searchIconColor = useColorModeValue("gray.700", "gray.200");
  const inputBg = useColorModeValue("white", "gray.800");

  const [ timer, setTimer ] = useState(null);


  const changeDelay = (change) => {

    if (timer) {
        clearTimeout(timer);
        setTimer(null);
    }
    setTimer(
        setTimeout(() => {
          setKeyword(change);
        }, 500)
    );
  }

  return (
    <InputGroup
      bg={inputBg}
      borderRadius="15px"
      w="200px"
      _focus={{
        borderColor: { mainTeal },
      }}
      _active={{
        borderColor: { mainTeal },
      }}
    >
      <InputLeftElement
        children={
          <IconButton
            bg="inherit"
            borderRadius="inherit"
            _hover="none"
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
          ></IconButton>
        }
      />
      <Input
        fontSize="xs"
        py="11px"
        placeholder={hint}
        borderRadius="inherit"
        defaultValue={keyword}
        onChange={(e) => changeDelay(e.target.value)}
      />
      {/* <IconButton 
        ml="8px"
        onClick={onReload}
        title="Reload Data"
        icon={<Icon as={FaCircleNotch} me="4px" />} 
      /> */}
    </InputGroup>
  );
}
